import { UserState } from './state'

const SET_LOGIN_EMAIL = (state: UserState, payload: string) => {
  state.loginEmail = payload
}

const SET_IS_DISPLAY_TOS_CHECKBOX = (state: UserState, payload: boolean) => {
  state.isDisplayTosCheckbox = payload
}

export default {
  SET_LOGIN_EMAIL,
  SET_IS_DISPLAY_TOS_CHECKBOX
}
